import React, { useState } from 'react';
import { flCapital } from '../../helpers/Utils';

function createElementFromHTML(htmlString) {
    var div = document.createElement('div');
    div.innerHTML = htmlString.trim();
  
    // Change this to div.childNodes to support multiple top-level nodes.
    return div.firstChild;
}

const GoBroadControl = (props) => {

    var year = props.data.year;
    var event_type = props.data.event_type;
    var the_event = props.data.event;
    var event_type_scope;

    if (event_type == 'Federal') {
        event_type_scope = 'national'
    } else if (event_type == 'Provincial') {
        event_type_scope = 'provincial'
    }

    return(
        <div>
            <div>
                <button style={{width:'100%', padding:'5px'}} onClick={() => props.broadControl()}>
                    <span role="img" aria-labelledby='Ballot box'>{props && props.year ? props.year : ''} Up to {year} {flCapital(event_type_scope)} {the_event} map</span>
                </button>
            </div>
        </div>
    )
}

export default GoBroadControl;